import customer from "./reducer";

export default customer;
